import { useMemo } from "react";

import { Stack } from "@mui/material";

import {
    ApprovalDataChange,
    ApprovalDataChangeAction,
} from "types/ApprovalDataChangeSet";
import { ApprovalDataChangeSetEntityActionData } from "./ApprovalDataChangeSetEntityActionData";

export interface ApprovalDataChangeSetEntityProps {
    entity: string;
    changes: ApprovalDataChange[];
}

export function ApprovalDataChangeSetEntity(
    props: ApprovalDataChangeSetEntityProps,
) {
    const tables = useMemo(() => {
        const entityData = props.changes.filter(
            (x) => x.entity === props.entity,
        );

        // show data per action
        return Object.values(ApprovalDataChangeAction).map((action) => {
            const actionData =
                entityData.filter((x) => x.action === action) ?? [];

            if (actionData?.length) {
                return (
                    <ApprovalDataChangeSetEntityActionData
                        key={`${props.entity}_${action}`}
                        action={action}
                        entity={props.entity}
                        changes={actionData}
                    />
                );
            }
        });
    }, [props.changes, props.entity]);

    return (
        <Stack
            spacing={3}
            children={tables}
        />
    );
}
